import { ColumnInterface } from "components/tables/interfaces";
import { OrderSorter } from "components/tables/sort";
import Table from "components/tables/table";
import { useListTemplates } from "stores/hooks/list-templates";
import { useLocale } from "stores/hooks/locale";
import { parse } from "lib/locale";
import { List } from "models/list";
import { useState } from "react";
import { useNavigate } from "react-router";
import { Fragment } from "react/jsx-runtime";
import AddListTemplateModal from "./add-list-template-modal";
import { fetchListTemplates } from "stores/actions/list-templates";
import { faArrowUpRightFromSquare } from "components/icon-library";
import { adminDoDeleteListTemplate } from "services/admin/list-template";
import { showError, showSuccess } from "lib/notification";

const AdminListTemplatesTable = () => {
  const [addModal, toggleAddModal] = useState(false);
  const listTemplates = useListTemplates();
  const locale = useLocale();
  const navigate = useNavigate();

  const columns: ColumnInterface[] = [
    {
      key: "name",
      header: "Nimi",
      render: (listTemplate: List) => (
        <div>{parse(listTemplate.name, locale)}</div>
      ),
    },
    {
      key: "lists",
      header: "Luetteloita",
      width: 150,
      render: (listTemplate: List) => {
        const count = listTemplate.lists.length;
        return count;
      },
    },
  ];

  const openListTemplate = (listTemplate: List) => {
    navigate(`/admin/list-template/${listTemplate.uuid}`);
  };

  const handleClickNewListTemplate = async () => {
    toggleAddModal(true);
  };

  const handleDeleteListTemplate = async (listTemplate: List) => {
    try {
      await adminDoDeleteListTemplate(listTemplate.uuid);
      await fetchListTemplates();
      showSuccess("Luettelomalli poistettu.");
    } catch (err) {
      showError("Luettelomallin poistaminen epäonnistui.");
    }
  };

  return (
    <Fragment>
      <Table
        name="admin-list-templates"
        title={undefined}
        columns={columns}
        data={listTemplates}
        sortFn={OrderSorter}
        searchHint="Etsi luettelomalleista"
        editers={[
          {
            onClick: async (listTemplate) => openListTemplate(listTemplate),
            icon: faArrowUpRightFromSquare,
          },
        ]}
        adder={{
          text: "Uusi luettelomalli",
          onClick: handleClickNewListTemplate,
        }}
        deleter={{
          isDisabled: () => {
            return listTemplates.length < 2;
          },
          onClick: handleDeleteListTemplate,
        }}
      />
      {addModal && (
        <AddListTemplateModal
          onChange={() => fetchListTemplates()}
          onClose={async () => {
            toggleAddModal(false);
          }}
        />
      )}
    </Fragment>
  );
};

export default AdminListTemplatesTable;
